module.exports = __webpack_public_path__ + "img/1550045558.4b126cd6.jpg";